import React from "react";
import { Box, Typography } from "@mui/material";

const CakeInfoSection = ({ cake }) => {
  return (
    <Box sx={{ px: 2, mt: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {cake.displayName}
      </Typography>

      <Box sx={{ minHeight: { xs: 0, md: 80 } }}>
        <Typography
          variant="body2"
          sx={{ color: "gray", mb: 3, minHeight: 80 }}>
          {cake.description}
        </Typography>
      </Box>
    </Box>
  );
};

export default CakeInfoSection;
